import { Component, OnInit } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { MainComponent } from './main.component';
import { MxIdentityService } from '../../services';

@Component({ standalone: false,
  selector: 'mx-inlinemenu',
  templateUrl: './inlinemenu.component.html',
  animations: [
    trigger('inline', [
      state(
        'hidden',
        style({
          height: '0px',
          overflow: 'hidden',
        })
      ),
      state(
        'visible',
        style({
          height: '*',
        })
      ),
      state(
        'hiddenAnimated',
        style({
          height: '0px',
          overflow: 'hidden',
        })
      ),
      state(
        'visibleAnimated',
        style({
          height: '*',
        })
      ),
      transition(
        'visibleAnimated => hiddenAnimated',
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')
      ),
      transition(
        'hiddenAnimated => visibleAnimated',
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')
      ),
    ]),
  ],
})
export class InlineMenuComponent implements OnInit {
  accountFullName: string;

  constructor(public main: MainComponent, public identityService: MxIdentityService) {}

  ngOnInit() {
    this.accountFullName = `${this.identityService.accountValue.firstName} ${this.identityService.accountValue.lastName}`;
  }
}
